import { forwardRef } from "react";

import { ASSIGNMENT_VOCABULARY } from "@/constants/ui/assignment";
import { PointInfo } from "@/domains/point";
import { AssignmentWithContext } from "@/pages/Assignments/AssignmentsPage/AssignmentPage.types";

import { StyledAssignmentHeader, StyledTypeContainer } from "./Styled";

interface AssignmentHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
    item: AssignmentWithContext;
}

export const AssignmentHeader = forwardRef<
    HTMLDivElement,
    AssignmentHeaderProps
>(({ item, ...rest }, ref) => {
    const { assignment, point } = item;

    const Icon =
        ASSIGNMENT_VOCABULARY?.[
            assignment.context.additionalData.assignmentType
        ]?.icon;

    return (
        <StyledAssignmentHeader {...rest} ref={ref}>
            <StyledTypeContainer>
                {Icon && <Icon />}
                <p>{assignment.name}</p>
            </StyledTypeContainer>
            <PointInfo point={point} />
        </StyledAssignmentHeader>
    );
});

AssignmentHeader.displayName = "AssignmentHeader";
